import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import Factura from './Factura';


interface FacturaTableProps {
  data: Factura[];
  columns: TableColumn<Factura>[];
  customStyles: Record<string, any>;
}

const BancoTable: React.FC<FacturaTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<Factura>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default BancoTable;